// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function blacklistingReason_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var description = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
    if (description.TAG === /* Ok */0) {
      var show_for_manual_blacklisting = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "show_for_manual_blacklisting"), null));
      if (show_for_manual_blacklisting.TAG === /* Ok */0) {
        var blacklist_type = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "blacklist_type"), null));
        if (blacklist_type.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    id: id._0,
                    description: description._0,
                    show_for_manual_blacklisting: show_for_manual_blacklisting._0,
                    blacklist_type: blacklist_type._0
                  }
                };
        }
        var e = blacklist_type._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".blacklist_type" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = show_for_manual_blacklisting._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".show_for_manual_blacklisting" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = description._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".description" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var blacklisting_reasons = Decco.arrayFromJson(blacklistingReason_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "blacklisting_reasons"), null));
  if (blacklisting_reasons.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              blacklisting_reasons: blacklisting_reasons._0
            }
          };
  }
  var e = blacklisting_reasons._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".blacklisting_reasons" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  blacklistingReason_decode ,
  t_decode ,
  
}
/* No side effect */
